export const dialogPaperSx = {
  width: 'calc(100% - 100px)',
  maxWidth: 1240,
  height: 'calc(100vh - 180px)',
  maxHeight: 900, // optional
  minHeight: 500, // optional
  m: 0,
  display: 'flex',
  flexDirection: 'column',
  borderRadius: '8px',
  overflow: 'hidden',
  bgcolor: '#FFFFFF'
};
export const dialogContentSx = {
  flex: '1 1 auto',
  minHeight: 0,
  p: '16px !important',
  overflow: 'hidden',
  bgcolor: '#FFFFFF'
};

export const panelsWrapperSx = {
  width: '100%',
  height: '100%',
  minHeight: 0,
  display: 'grid',

  gridTemplateColumns: {
    xs: '1fr',
    md: 'minmax(0, 1fr) minmax(0, 1fr)'
  },

  gridTemplateRows: {
    xs: 'minmax(400px, 1fr) minmax(400px, 1fr)',
    md: 'minmax(0, 1fr)'
  },

  gap: 1.5,

  overflow: {
    xs: 'auto',
    md: 'hidden'
  },

  '& > *': {
    minWidth: 0,
    minHeight: 0
  }
};